'use strict';

var jsxRuntime = require('react/jsx-runtime');
var react = require('react');
var icons_IconInfo = require('../../icons/IconInfo.js');
var utilities_combineClasses = require('../../_chunks/combineClasses-5P8GTQkg.js');
var components_tooltip_Tooltip = require('../tooltip/Tooltip.js');
require('../../icons/Icon.js');
require('../../_chunks/index-CIVOGJRG.js');
require('../../_chunks/designTokens-CKP-YoT2.js');
require('../../hooks/useCombinedRefs.js');
require('../../_chunks/useDevelopmentEffect-DGG0KnB_.js');
require('../../hooks/useFocus.js');
require('../../hooks/useHover.js');
require('lodash/isNumber');
require('../../hooks/useUUID.js');
require('../../_chunks/useOnEscape-vb8gPtDo.js');
require('../../_chunks/useEventListener-DSwo06ND.js');
require('../../hooks/useCallbackRef.js');
require('../floatingContainer/FloatingContainer.js');
require('@floating-ui/react-dom');
require('../../transitions/fade/Fade.js');
require('react-transition-group');
require('../portal/Portal.js');
require('react-dom');
require('../../theme/ThemeProvider.js');

require("../../_assets/TooltipIndicator-B6I7b520.css");var styles = {"tooltipIndicator":"TooltipIndicator__EPAKwq4XyU__tooltipIndicator"};

const TooltipIndicator = react.forwardRef(({ iconProps, size, tabIndex, ...props }, ref) => (jsxRuntime.jsx(components_tooltip_Tooltip.Tooltip, { testId: "tooltip", attachAs: 
    // screen readers don't announce descriptions the tooltip indicator when accessed via the virtual cursor
    // so we attach the tooltip text as a label instead
    'label', ...props, children: jsxRuntime.jsx(icons_IconInfo.IconInfo, { tabIndex: tabIndex ?? 0, size: size, ...iconProps, className: utilities_combineClasses.combineClasses(styles.tooltipIndicator, iconProps?.className), ref: ref }) })));
TooltipIndicator.displayName = 'TooltipIndicator';

exports.TooltipIndicator = TooltipIndicator;
//# sourceMappingURL=TooltipIndicator.js.map
